var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ds-search-panel"},[_c('div',{staticClass:"ds-search-panel__body"},[_vm._t("default")],2),_c('div',{staticClass:"ds-search-panel__actions"},[_vm._t("actions")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }